import type { ItandiHeader } from "@itandi/brand-ui/ItandiHeader";
import type { ComponentProps } from "react";
import useItandiAccount from "~/hooks/useItandiAccount";

type ReturnType = {
	// NOTE: ひとまずNSKと関わりのあるアプリケーションのみ
	useBKK: boolean;
	useItandiTask: boolean;
	useKT: boolean;
	useSK: boolean;
};

/**
 * @for client
 */
export const useUsingApplications = (): ReturnType => {
	const { data: currentAccount } = useItandiAccount().currentAccount();
	const detectProductCode = (
		productCode: ComponentProps<typeof ItandiHeader>["productCode"]
	): boolean => {
		if (currentAccount === null) {
			return false;
		}
		return currentAccount.productParams.some(
			(menu: ComponentProps<typeof ItandiHeader>["productMenus"][number]) =>
				menu.code === productCode
		);
	};
	return {
		useBKK: detectProductCode("bkk"),
		useItandiTask: detectProductCode("itandi-task"),
		useKT: detectProductCode("kt"),
		useSK: detectProductCode("sk")
	};
};
